
import { Card as QCard, Text as QText } from '@qoala/ui';
import Vue from 'vue';

export default Vue.extend({
  name: 'AddToHomeScreen',
  components: {
    QText,
    QCard,
  },
  data: () => ({
    deferredPrompt: null as any,
  }),
  mounted() {
    this.captureEvent();
  },
  methods: {
    captureEvent() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        this.deferredPrompt = e;
      });
    },
    handleAddToHomescreen() {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then(() => {
        this.deferredPrompt = null;
      });
    },
    handleClose() {
      this.deferredPrompt = null;
    },
  },
});
